module.exports = __webpack_public_path__ + "images/history-cat-1-2f46255f94a8c710605f3822984656b3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/history-cat-1.png
 ** module id = 388
 ** module chunks = 0
 **/